module.exports = __webpack_public_path__ + "static/img/home_top_bg1.b7bd194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_top_bg1.png
// module id = iM/O
// module chunks = 1